import script from "./ResourceDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceDetail.vue?vue&type=style&index=0&id=7e1ceaa9&lang=scss&scoped=true"
import "./ResourceDetail.vue?vue&type=style&index=1&id=7e1ceaa9&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1ceaa9"]])

export default __exports__